import { Component, EventEmitter, Inject, Input, LOCALE_ID, Output } from '@angular/core';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CustomMessagesService } from '../../services/custom-messages.service';
import { locales } from 'src/app/resources/locales';
import { User } from 'src/app/global-functions';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-header-component',
    templateUrl: './header.commponent.html'
})
export class HeaderComponent {
    @Output() public toggle = new EventEmitter();
    @Input() public selectedPage?: string;

    public customMsgService: CustomMessagesService;
    public userName: string = '';
    public userType: string = '';
    public versaoBackend: string = '';//todo fazer chmada a api para obter a versão
    public versaoWeb: string = ''; //todo ao dar commit ele encrementa a versão automaticamente 
    public selectedLanguage = { locale: 'Portugal', localeId: 'pt' };
    public locales = locales;
    public popupSettings = { width: '150' };
    public themes: { href: string, text: string }[] = [
        {
            href: 'assets/kendo-theme-default/dist/all.css',
            text: 'Bootstrap'
        }, {
            href: 'assets/kendo-theme-default/dist/default-ocean-blue.css',
            text: 'Default'
        }, {
            href: 'assets/kendo-theme-material/dist/all.css',
            text: 'Material'
        }
    ];
    public selectedTheme = this.themes[0];
    public showInfoBalloon: boolean = false; 

    constructor(public messages: MessageService, @Inject(LOCALE_ID) public localeId: string, public intlService: IntlService, private router: Router, private auth: AuthService) {
        var user = User.userInSession();

        this.localeId = user.LocateID;
        this.setLocale(this.localeId);

        this.userName = user.Nome;
        this.userType = user.Funcao;
        this.versaoBackend = user.versaoBackend;
        this.customMsgService = this.messages as CustomMessagesService;
        this.customMsgService.language = this.localeId;
    }

    public changeTheme(theme: { href: string, text: string }) {
        this.selectedTheme = theme;
        const themeEl: any = document.getElementById('theme');
        themeEl.href = theme.href;
    }

    public changeLanguage(item: any): void {
        this.customMsgService.language = item.localeId;
        this.setLocale(item.localeId);
    }

    public setLocale(locale: any): void {
        (this.intlService as CldrIntlService).localeId = locale;
    }

    public onButtonClick(): void {
        this.toggle.emit();
    }

    public changePass(): void {
        this.router.navigate(['change-pass']);
    }

    public logOut(): void {
        this.auth.logout();
        this.router.navigate(['login']);

    }

    public onclick(): void {
        this.router.navigate(['dashboard']);
    }

    public toggleInfoBalloon(): void {
        this.showInfoBalloon = !this.showInfoBalloon;
    }

    public items: any[] = new Array<any>();
}